import { render, staticRenderFns } from "./OutboundLink.vue?vue&type=template&id=9b4dba4e&functional=true&"
var script = {}
import style0 from "./OutboundLink.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports